import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Card,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { ORG_MENUCATEGORY_CREATE } from "../../../api/endpoints";

const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

const AddMenuCategory = ({
  isOpen,
  toggleModal,
  onSubmit,
  data,
  refreshData,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]); // Initialize state for selected files
  const user = JSON.parse(localStorage.getItem("user"));

  // Initial values for the form
  const initialValues = {
    name: "",
    menuType: "",
    image: "", // This will hold the image name (or file name)
    parentId: "",
    isKot: false,
    isBot: false,
  };

  // Validation Schema using Yup
  const validationSchema = Yup.object({
    name: Yup.string(),
    menuType: Yup.string(),
    image: Yup.string(),
    parentId: Yup.string().optional(),
    isKot: Yup.boolean(),
    isBot: Yup.boolean(),
  });
  const handleAcceptedFiles = (files, setFieldValue) => {
    const formattedFiles = files.map((file) => ({
      ...file,
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    }));

    setSelectedFiles([...formattedFiles]);

    if (files.length > 0) {
      setFieldValue("image", files[0]);
    }
  };

  const handleFileRemove = (indexToRemove, setFieldValue) => {
    setSelectedFiles((prevFiles) => {
      const newFiles = prevFiles.filter((_, index) => index !== indexToRemove);
      if (newFiles.length === 0) {
        setFieldValue("image", null);
      }
      return newFiles;
    });
  };
  // Handle the form submission
  const handleSubmit = async (values) => {
    setLoading(true);
    console.log(values);
    try {
      const formData = new FormData();

      // Append form fields
      formData.append("name", values.name);
      formData.append("menuType", values.menuType);
      formData.append("parentId", values.parentId || ""); // Optional field can be an empty string if not provided
      formData.append("isKot", values.isKot);
      formData.append("isBot", values.isBot);
      // Append image if it exists
      if (values.image) {
        formData.append("image", values.image);
      }

      // Send the form data to the server via Axios
      const response = await axios.post(
        ORG_MENUCATEGORY_CREATE,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", 
            "Authorization": `Bearer ${user.accessToken}`,
          },
        }
      );
      console.log("Response from server: ", response);
      // refreshData();
      setTimeout(() => {
        toast.success("Form is submmitted successful");
        refreshData();
        setLoading(false);
        toggleModal(); // Close modal after submission
      }, 2500);
      // window.location.reload();
    } catch (error) {
      console.error("Error during submission: ", error);
      toast.error("Failed to submit category. Please try again.");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setSelectedFiles([]);
    }
  }, [isOpen]);

  const handleRadioChange = (setFieldValue, value) => {
    if (value === "isKot") {
      setFieldValue("isKot", true);
      setFieldValue("isBot", false);
    } else {
      setFieldValue("isKot", false);
      setFieldValue("isBot", true);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>Add Menu Category</ModalHeader>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, values, handleChange }) => (
            <Form>
              <Row>
                <Col md={6}>
                  <FormGroup>
                    <Dropzone
                      onDrop={(acceptedFiles) =>
                        handleAcceptedFiles(acceptedFiles, setFieldValue)
                      }
                    >
                      {({ getRootProps, getInputProps }) => (
                        <div className="dropzone dz-clickable pt-3">
                          <div
                            className="dz-message needsclick mb-5 p-3"
                            {...getRootProps()}
                          >
                            <i className="align-item-center display-4 text-muted ri-upload-cloud-2-fill" />
                            <input {...getInputProps()} />
                            <h6 className="fs-15 fw-semi-bold pt-3">
                              Drop files here or{" "}
                              <Link to="#">click to upload.</Link>
                            </h6>
                            {selectedFiles.map((f, i) => (
                              <Card
                                key={i}
                                className="mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                              >
                                <Row className="align-items-center">
                                  <Col className="col-auto">
                                    <img
                                      height="100"
                                      className="avatar-sm rounded bg-light"
                                      alt={f.name}
                                      src={f.preview}
                                    />
                                  </Col>
                                  <Col>
                                    <Link
                                      to="#"
                                      className="text-muted font-weight-bold"
                                    >
                                      {f.name}
                                    </Link>
                                    <p className="mb-0 fs-12">
                                      {f.formattedSize}
                                    </p>
                                  </Col>
                                  <Col lg={2}>
                                    <Link
                                      onClick={() =>
                                        handleFileRemove(i, setFieldValue)
                                      }
                                    >
                                      <h6>
                                        <i className="ri-delete-bin-2-line text-danger"></i>
                                      </h6>
                                    </Link>
                                  </Col>
                                </Row>
                              </Card>
                            ))}
                          </div>
                        </div>
                      )}
                    </Dropzone>
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="name">
                          Name <span className="text-danger">*</span>
                        </Label>
                        <Field
                          name="name"
                          type="text"
                          placeholder="Enter Name"
                          className="form-control"
                          id="name"
                        />
                        <ErrorMessage
                          name="name"
                          component="div"
                          className="text-danger"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={12}>
                      <FormGroup>
                        <Label for="menuType">
                          Menu Type <span className="text-danger">*</span>
                        </Label>
                        <Field
                          name="menuType"
                          as="select"
                          className="form-control"
                          id="menuType"
                        >
                          <option value="">Select Menu Type</option>
                          <option value="1">Food Menu</option>
                          <option value="2">Drink Menu</option>
                          <option value="3">Others</option>
                        </Field>{" "}
                        <ErrorMessage
                          name="menuType"
                          component="div"
                          className="text-danger"
                        />
                      </FormGroup>
                    </Col>

                    <Col md={12}>
                      <FormGroup>
                        <Label for="parentId">Parent Category</Label>
                        <Field
                          name="parentId"
                          as="select"
                          className="form-control"
                          id="parentId"
                        >
                          <option value="">Select Category</option>{" "}
                          {data?.map((item, index) => (
                            <option key={index} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="parentId"
                          component="div"
                          className="text-danger"
                        />
                      </FormGroup>
                    </Col>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="isKot">Is KOT</Label>
                          <Field
                            name="isKot"
                            type="radio"
                            value="isKot"
                            className="form-check-input"
                            id="isKot"
                            checked={values.isKot === true}
                            onChange={() =>
                              handleRadioChange(setFieldValue, "isKot")
                            }
                          />

                          <ErrorMessage
                            name="isKot"
                            component="div"
                            className="text-danger"
                          />
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <FormGroup>
                          <Label for="isBot">Is BOT</Label>
                          <Field
                            name="isBot"
                            type="radio"
                            value="isBot"
                            className="form-check-input"
                            id="isBot"
                            checked={values.isBot === true}
                            onChange={() =>
                              handleRadioChange(setFieldValue, "isBot")
                            }
                          />

                          <ErrorMessage
                            name="isBot"
                            component="div"
                            className="text-danger"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Row>
                </Col>
              </Row>

              <ModalFooter>
                <Button color="danger" onClick={toggleModal}>
                  Cancel
                </Button>
                <Button type="submit" color="success" disabled={loading}>
                  {loading && (
                    <Spinner size="sm" className="me-2">
                      Loading...
                    </Spinner>
                  )}{" "}
                  {loading ? "Submitting..." : "Submit"}
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default AddMenuCategory;
